
import { NewPurchaseRequestDialog } from "@/components/inventory/NewPurchaseRequestDialog";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function PurchaseRequest() {
  const [showDialog, setShowDialog] = useState(true);
  const navigate = useNavigate();
  
  const handleDialogClose = (created: boolean) => {
    setShowDialog(false);
    
    // Redirect back to inventory page
    if (created) {
      navigate("/inventory?tab=requests");
    } else {
      navigate("/inventory");
    }
  };
  
  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-6">New Purchase Request</h1>
      
      <p className="mb-4">
        Fill out the form to submit a new purchase request for approval.
      </p>
      
      <NewPurchaseRequestDialog 
        open={showDialog} 
        onClose={handleDialogClose} 
      />
    </div>
  );
}
